// Created by hejikun on 2017/11/2 0002.
let famousDoc = [
  {
    path: '/famousDocIndex',
    name: '疑难重症全国直通',
    component: () => import('@/pages/famousDoc/famousDocIndex')
  },
  {
    path: '/famousDocdoc_index',
    name: '专家详情',
    component: () => import('@/pages/famousDoc/famousDocdoc_index')
  },
  {
    path: '/famousDocOrderConfirm',
    name: '订单确认',
    component: () => import('@/pages/famousDoc/famousDocOrderConfirm')
  },
  {
    path: '/famousDocDetail',
    name: '疑难重症全国直通',
    component: () => import('@/pages/famousDoc/famousDocDetail')
  },
  {
    path: '/famousDocOrderList',
    name: '订单列表',
    component: () => import('@/pages/famousDoc/famousDocOrderList')
  },
  {
    path: '/famousDocOrderPay',
    name: '支付订单',
    component: () => import('@/pages/famousDoc/famousDocOrderPay')
  },
  {
    path: '/famousDocOrderDetail',
    name: '订单详情',
    component: () => import('@/pages/famousDoc/famousDocOrderDetail')
  },
  {
    path: '/tumourIndex',
    name: '肿瘤专区',
    component: () => import('@/pages/famousDoc/tumourIndex')
  },
  {
    path: '/tumourIndex_new',
    name: '肿瘤专区',
    component: () => import('@/pages/famousDoc/tumourIndex_new')
  },
  {
    path: '/tumourDepList',
    name: '科室列表',
    component: () => import('@/pages/famousDoc/tumourDepList')
  },
  {
    path: '/tumour_physicalExamination',
    name: '防癌筛查',
    component: () => import('@/pages/famousDoc/tumour_physicalExamination')
  },
  {
    path: '/famousDocRegistrationConfirm',
    name: '疑难重症全国直通',
    component: () => import('@/pages/famousDoc/famousDocRegistrationConfirm')
  },
  {
    path: '/tumourIndex_dxk_new',
    name: '多学科会诊医院列表',
    // component: () => import('@/pages/famousDoc/tumourIndex_dxk')
    component: () => import('@/pages/famousDoc/tumourIndex_dxk_new')
  },
  {
    path: '/tumourIndex_dxk',
    name: '多学科会诊医院列表',
    component: () => import('@/pages/famousDoc/tumourIndex_dxk')
    // component: () => import('@/pages/famousDoc/tumourIndex_dxk_new')
  },
  {
    path: '/free_clinic_entrance',
    name: '抗癌康复协会会员问诊',
    component: () => import('@/pages/famousDoc/freeClinicEntrance')
  },
  {
    path: '/free_clinic_doclist',
    name: '病情咨询',
    component: () => import('@/pages/famousDoc/freeClinicDocList')
  },
  {
    path: '/free_clinic_joinVIP',
    name: '加入会员',
    component: () => import('@/pages/famousDoc/freeClinicJoinVIP')
  },
  {
    path: '/free_clinic_join_entrance',
    name: '加入会员',
    component: () => import('@/pages/famousDoc/freeClinicJoinVIPEntrance')
  },
  {
    path: '/free_clinic_join_concept',
    name: '加入会员',
    component: () => import('@/pages/famousDoc/freeClinicJoinVIPConcept')
  },
  {
    path: '/tumour_hos_list_new',
    name: '医院列表',
    // component: () => import('@/pages/famousDoc/tumour_hos_list')
    component: () => import('@/pages/famousDoc/tumour_hos_list_new')
  },
  {
    path: '/tumour_hos_list',
    name: '医院列表',
    component: () => import('@/pages/famousDoc/tumour_hos_list')
    // component: () => import('@/pages/famousDoc/tumour_hos_list_new')
  },
  {
    // path: '/tumour_dep_list',
    path: '/tumour_dep_list_new',
    name: '科室列表',
    component: () => import('@/pages/famousDoc/tumour_dep_list_new')
  },
  {
    path: '/tumour_dep_list',
    // path: '/tumour_dep_list_new',
    name: '科室列表',
    component: () => import('@/pages/famousDoc/tumour_dep_list')
  },
  {
    path: '/cancer_multiple_dep',
    name: '肿瘤医院多学科',
    component: () => import('@/pages/famousDoc/cancer_multiple_dep')
  }
]

export default famousDoc
